import {apiGetReportProfitAndLoss} from "api/reportApi";
import {HeaderActions, PageHeader, ReportActions} from "components/Reports/components";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ProfitAndLossList from "./ProfitAndLossList";
import {Container} from "@mui/material";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import useDateState from "helpers/useDateState";

const tab = {
    title: "صورت سود و زیان",
    description: "گزارش سود و زیان کسب و کار",
};

const BillProfitLossComponent = () => {
    const dispatch = useDispatch();
    const {toDate, fromDate, setDates} = useDateState();
    const {token} = useSelector((state: any) => state).businessReducer.business;

    const {profitAndLoss} = useSelector((state: any) => state).reportReducer;

    // useEffect(() => {
    //     // @ts-ignore
    //     dispatch(apiGetReportProfitAndLoss(token));
    // }, [token]);

    useEffect(() => handleDateFilter(), [toDate, fromDate]);

    function handleDateFilter() {
        let params = {};
        if (fromDate && toDate) {
            params = {
                subColumn: "date",
                searchText: fromDate,
                searchTextAlt: toDate,
            };
        }
        // @ts-ignore
        dispatch(apiGetReportProfitAndLoss(token, params));
    }

    return (
        <Container maxWidth="lg">
            <div className="warp-table">
                <div className="header-table">
                    <PageHeader tab={tab}/>
                    <HeaderActions/>
                </div>
                <div style={{display: "flex", alignItems: "center", gap: 20}}>
                    <ReportActions/>
                    <div style={{width: 300}}>
                        <BasicDateInput
                            range
                            placeholder="کل سال مالی"
                            onChange={(dates) => setDates(dates)}
                            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                        />
                    </div>
                </div>
                <div style={{width: "100%", height: 40}}/>
                {profitAndLoss && <ProfitAndLossList data={profitAndLoss}/>}
            </div>
        </Container>
    );
};

export default BillProfitLossComponent;
